import { render, staticRenderFns } from "./MenuTransportes.vue?vue&type=template&id=1c0cd321&"
import script from "./MenuTransportes.vue?vue&type=script&lang=js&"
export * from "./MenuTransportes.vue?vue&type=script&lang=js&"
import style0 from "./MenuTransportes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports